export enum Icons {
  ACCOUNT = 'account',
  ADDITION_SIGN = 'addition-sign',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  BELL = 'bell',
  BELL_MARKED = 'bell-marked',
  BLACK_ARROW_RIGHT = 'black-arrow-right',
  BLACK_INFO = 'black-info',
  BLACK_LOGO = 'black-logo',
  CALENDAR = 'calendar',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_LEFT = 'chevron-left',
  CLOSE_CIRCLE = 'close',
  CLOSE = 'x-close',
  DOWNLOAD = 'download',
  DOWNLOAD_ARROW_SIGN = 'download-arrow-sign',
  ERROR = 'error',
  EDIT = 'edit',
  EDIT_WHITE = 'edit-white',
  EYE_CLOSED = 'eye-closed',
  EYE_OPEN = 'eye-open',
  GEAR = 'gear',
  INFO = 'info',
  LOADING = 'loading',
  CIRCLE_LOADING = 'circle-loading',
  QUESTION_MARK = 'question-mark',
  PLAY = 'play',
  PLUS = 'plus',
  REQUIRED = 'required',
  SEARCH = 'search',
  SUCCESS = 'success',
  SUBTRACT_SIGN = 'subtract-sign',
  SWISS_FLAG = 'swiss-flag',
  TRASH = 'trash',
  TRIANGLE_WARNING = 'triangle-warning',
  WARNING = 'warning',
  WHITE_DELETE = 'white-delete',
  TRANSPARENT_INFO_ICON = 'transparent-info-icon',
  WHITE_LOGO = 'white-logo',
  XLSX_FILE = 'xlsx-file',
}

export type IconValues = `${Icons}`;
